
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"32","viewBox":"0 0 31 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"14.192","cy":"15.125","r":"10.725","fill":"#32A03D"}}),_c('path',{attrs:{"d":"M15.289 31.17c8.162 0 14.946-6.77 14.946-14.947 0-8.162-6.8-14.946-14.961-14.946C7.098 1.277.343 8.06.343 16.223c0 8.177 6.769 14.947 14.946 14.947zm-2.022-7.43c-.498 0-.88-.22-1.304-.718l-4.22-5.216a1.59 1.59 0 01-.352-.953c0-.689.542-1.216 1.187-1.216.425 0 .777.16 1.128.616l3.503 4.527 6.813-10.916c.279-.455.66-.675 1.04-.675.646 0 1.276.426 1.276 1.129 0 .322-.19.674-.381.967l-7.445 11.737c-.322.484-.733.718-1.245.718z","fill":"#CEF4CB"}})])
          )
        }
      }
    